import React, { useState, useRef } from "react";

function MagnifierImage({ src, zoom = 2 }) {
  const [showZoom, setShowZoom] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const containerRef = useRef();

  const lensSize = 100; // Size of the lens square

  const handleMouseMove = (e) => {
    const { left, top, width, height } = containerRef.current.getBoundingClientRect();
    const x = e.clientX - left;
    const y = e.clientY - top;

    setPosition({
      x: Math.max(0, Math.min(x, width)),
      y: Math.max(0, Math.min(y, height)),
      containerWidth: width,
      containerHeight: height,
    });
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* Fixed-size Original Image */}
      <div
        ref={containerRef}
        onMouseEnter={() => setShowZoom(true)}
        onMouseLeave={() => setShowZoom(false)}
        onMouseMove={handleMouseMove}
        style={{
          // width: "400px",
          // maxHeight: "450px",
          overflow: "hidden",
          borderRadius: "5px",
          border: "1px solid #ddd",
          position: "relative",
          objectFit: "fill",
        }}
      >
        <img
          src={src}
          alt="Product" className="img-fluid" 
        />

        {/* Zoom Lens */}
        {showZoom && (
          <div
            style={{
              position: "absolute",
              top: position.y - lensSize / 2,
              left: position.x - lensSize / 2,
              width: `${lensSize}px`,
              height: `${lensSize}px`,
              border: "1px solid #aaa",
              backgroundColor: "rgba(255,255,255,0.3)",
              pointerEvents: "none",
              zIndex: 2,
            }}
          />
        )}
      </div>

      {/* Floating Zoom Box */}
      {showZoom && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: "600px", // positioned to the right of image
            width: "300px",
            height: "300px",
            border: "1px solid #ccc",
            background: `url(${src}) no-repeat`,
            backgroundSize: `${position.containerWidth * zoom}px ${position.containerHeight * zoom}px`,
            backgroundPosition: `-${position.x * zoom - 150}px -${position.y * zoom - 150}px`,
            borderRadius: "5px",
            boxShadow: "0 0 8px rgba(0,0,0,0.2)",
            zIndex: 9999,
            backgroundColor: "#fff",
          }}
        />
      )}
    </div>
  );
}

export default MagnifierImage;
